import { useTheme } from "styled-components";
import { useEffect, useState } from "react";
import { Breakpoint } from "../theme";

// Define type-safe breakpoint keys

/**
 * Custom hook to check if the screen matches a given breakpoint
 * @param breakpoint "mobile" | "tablet" | "laptop" | "desktop" | "ultraWide"
 * @returns boolean - whether the media query matches
 */
export const useMediaQuery = (breakpoint: Breakpoint): boolean => {
  const theme = useTheme();
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    const query = `(max-width: ${theme.breakpoints[breakpoint]})`;
    const media = window.matchMedia(query);

    const handleChange = () => setIsMatch(media.matches);
    handleChange(); // set initial match

    media.addEventListener("change", handleChange);
    return () => media.removeEventListener("change", handleChange);
  }, [breakpoint, theme.breakpoints]);

  return isMatch;
};